module.exports = __webpack_public_path__ + "media/background.e77a255c.mp4";